import { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useFormContext } from "react-hook-form";
import { useCoordinator } from "@shared/lib/hooks";
import { useNavigate, routes } from "@shared/lib/react-router";


export function ObjectFormClose() {
  const navigate = useNavigate();
  const { projectId, objectId } = useCoordinator();
  const [isOpen, setIsOpen] = useState(false);
  const {
    formState: { isDirty, isSubmitted },
  } = useFormContext();

  const handleClick = () => {
    if (isDirty && !isSubmitted) {
      setIsOpen(true);
    } else {
      navigate(routes.objects.object(projectId, objectId));
    }
  };

  const onOk = () => {
    navigate(routes.objects.object(projectId, objectId));
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <CloseOutlined className="object-form-icon-close" onClick={handleClick} />
      <Modal
        open={isOpen}
        title="Вы уверены?"
        centered
        onClose={onClose}
        onCancel={onClose}
        onOk={onOk}
      >
        Внесенные изменения не сохранятся
      </Modal>
    </>
  );
}
